import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { AnalyticsDirectivesModule } from '@analytics/events';
import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';
import { UtilsModule } from '@innogy/utils-deprecated';
import { EplusUploadFileService } from '@innogy/feh/services';
import { CommonUiFormsModule } from '@innogy/common-ui/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { RfaBasicFormExample1Component } from './level1';
import {
  RfaAddressComponent,
  RfaAppointmentComponent,
  RfaBasicFormExample2Component,
  RfaCheckboxComponent,
  RfaConditionalValidationComponent,
  RfaErrorsComponent,
  RfaLabelComponent,
  RfaNameComponent,
  RfaNumberInputComponent,
  RfaRadioGroupComponent,
  RfaSelectComponent,
  RfaSubmitComponent,
  RfaSubmitErrorComponent,
  RfaTextAreaComponent,
  RfaTextInputComponent,
  RfaPrefixSuffixComponent,
} from './level2';
import {
  RfaBasicFormExample3Component,
  RfaBasicStepperExampleComponent,
  RfaFormBuilderComponent,
  RfaFormControlBuilderComponent,
  RfaFormGroupBuilderComponent,
  RfaStepComponent,
  RfaStepperComponent,
} from './level3';
import { RfaFileUploadComponent } from './level2/components/rfa-file-upload';
import { ScrollToTopErrorDirective } from './level1/directives/ScrollToError.directive';
import { FehCrntDesignSystemModule } from './feh-crnt-design-system.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AnalyticsDirectivesModule,
    CommonUiFormsModule,
    CommonUiUtilityComponentsModule,
    UtilsModule,
    FehCrntDesignSystemModule,
    FaIconComponent,
    RfaErrorsComponent,
    RfaAddressComponent,
    RfaAppointmentComponent,
    RfaNameComponent,
    RfaRadioGroupComponent,
    RfaFileUploadComponent,
    RfaLabelComponent,
    RfaNumberInputComponent,
    RfaPrefixSuffixComponent,
  ],
  declarations: [
    // builders
    RfaFormBuilderComponent,
    RfaFormGroupBuilderComponent,
    RfaFormControlBuilderComponent,
    RfaStepComponent,
    RfaStepperComponent,
    RfaSubmitComponent,
    RfaSubmitErrorComponent,
    // components
    RfaTextInputComponent,
    RfaCheckboxComponent,
    RfaTextAreaComponent,
    RfaSelectComponent,
    // examples
    RfaConditionalValidationComponent,
    RfaBasicFormExample1Component,
    RfaBasicFormExample2Component,
    RfaBasicFormExample3Component,
    RfaBasicStepperExampleComponent,
    // directives
    ScrollToTopErrorDirective,
  ],
  exports: [
    ReactiveFormsModule,
    // utils
    RfaLabelComponent,
    RfaErrorsComponent,
    RfaSubmitComponent,
    RfaSubmitErrorComponent,
    //builders
    RfaFormBuilderComponent,
    RfaStepComponent,
    RfaStepperComponent,
    // components
    RfaTextInputComponent,
    RfaNumberInputComponent,
    RfaRadioGroupComponent,
    RfaCheckboxComponent,
    RfaTextAreaComponent,
    RfaSelectComponent,
    RfaFileUploadComponent,
    RfaAddressComponent,
    RfaNameComponent,
    RfaAppointmentComponent,
    RfaNameComponent,
    // examples
    // RfaConditionalValidationComponent,
    // RfaBasicFormExample1Component,
    // RfaBasicFormExample2Component,
    // RfaBasicFormExample3Component,
    // RfaBasicStepperExampleComponent,
    // directives
    ScrollToTopErrorDirective,
  ],
  providers: [EplusUploadFileService],
})
export class ReactiveFormsAbstractionsModule {}
